import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    .category {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        font-size: .9em;
        color: #484A52;
        text-transform: uppercase;
        cursor: pointer;


        .category-title {
            font-size: 1em;

            &:hover {
                color: #262626;
                box-shadow: 0 .15em 0 0 #C09E4B;
            }
        }

        .dot {
            color: #BA9449;
            font-size: .8em;
            padding: 0 1em;
        }

        &:last-of-type {
            margin-right: 0;

            .dot {
                display: none;
            }
        }
    }

    @media all and (max-width: ${variables.tabletL}) {}
`;
